<div class="accordeon topbar-filter-container">
  <div
    [@openCloseCollapse]="isCollapsed && showOnMobile ? 'closed' : 'open'"
    class="accordion-container">
    <ng-content></ng-content>
  </div>
  <ng-content select="[uncollapsable]"></ng-content>
  <button *ngIf="!isCollapsed" fill="clear" class="visibility-button" (click)="toggle()">
    <ion-icon color="primary" src="assets/icon/ic_chevron-up.svg"></ion-icon>
    {{ 'SIDEBAR.HIDE_VISIBILITY_LABEL' | translate }}
  </button>
  <button *ngIf="isCollapsed" fill="clear" class="visibility-button" (click)="toggle()">
    <ion-icon color="primary" src="assets/icon/ic_chevron-down.svg"></ion-icon>
    {{ 'SIDEBAR.SHOW_VISIBILITY_LABEL' | translate }}
  </button>
</div>
